import React from 'react';
import { Form, Input, Select } from 'antd';
import {
  EMPLOYMENT_STATUS_OPTIONS,
  EMPLOYMENT_TYPE_OPTIONS,
  YEARS_OF_EXPERIENCE_OPTIONS
} from '../../../../Utils/sriLankaGeoData';

const { Option } = Select;

const Section05Employment = () => {
  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-badge">SECTION 05</span>
        <h3>Employment Information</h3>
        <p className="section-description">
          Since most IBAS students are working professionals, this section helps us understand your industry context and tailor relevant business case studies.
        </p>
      </div>

      <div className="form-grid">
        <div className="grid-two-cols">
          <Form.Item
            label="Employment Status"
            name="employmentStatus"
            rules={[{ required: true, message: 'Please select your employment status' }]}
            initialValue="employed"
          >
            <Select size="large" placeholder="Select employment status">
              {EMPLOYMENT_STATUS_OPTIONS.map((opt) => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Employment Type (Optional)" name="employmentType">
            <Select size="large" placeholder="Select employment type" allowClear>
              {EMPLOYMENT_TYPE_OPTIONS.map((type) => (
                <Option key={type} value={type}>
                  {type}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div className="grid-two-cols">
          <Form.Item label="Company / Organization Name" name="companyName" extra="Recommended for working professionals">
            <Input placeholder="e.g. MAS Holdings / Commercial Bank / Brandix" size="large" />
          </Form.Item>

          <Form.Item label="Job Title / Designation" name="jobTitle" extra="Recommended for certificate profile matching">
            <Input placeholder="e.g. Accounts Executive / Data Analyst / Manager" size="large" />
          </Form.Item>
        </div>

        <div className="grid-two-cols">
          <Form.Item label="Department / Division (Optional)" name="department">
            <Input placeholder="e.g. Finance & Accounting / Supply Chain / IT" size="large" />
          </Form.Item>

          <Form.Item label="Industry / Sector (Optional)" name="industry">
            <Input placeholder="e.g. Banking, Apparel, Logistics, Telecommunication" size="large" />
          </Form.Item>
        </div>

        <div className="grid-two-cols">
          <Form.Item label="Years of Work Experience (Optional)" name="yearsOfExperience">
            <Select size="large" placeholder="Select experience duration" allowClear>
              {YEARS_OF_EXPERIENCE_OPTIONS.map((yr) => (
                <Option key={yr} value={yr}>
                  {yr}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Work Location / City (Optional)" name="workLocation">
            <Input placeholder="e.g. Colombo, Katunayake, Kandy" size="large" />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default Section05Employment;
